'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-category-overview__buttons {\n  display: flex;\n  justify-content: flex-end; }\n";
styleInject_es(css_248z);
